const dropdownItemStyle = {
  minHeight: '48px',
  selectors: {
    '& div.attribute-item': {
      width: '290px',
      padding: '4px',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
    '& span.attribute-sample': {
      color: '#767676',
      fontSize: '12px',
    },
  },
};

export const dropdownStyles = {
  root: {
    marginBottom: '32px',
  },
  dropdown: {
    selectors: {
      ':focus:after': {
        border: '1px solid #0078d4',
      },
    },
  },
  dropdownItem: dropdownItemStyle,
  dropdownItemSelected: dropdownItemStyle,
  title: {
    borderColor: '#b3b0ad',
  },
};

export const textFieldStyles = {
  root: {
    marginBottom: '32px',
  },
};
